export default "__VITE_ASSET__CV6lQUnp__"